export const AuthModalMode = {
  /** @type {AuthModalMode} Allow both login and signup modes. Display a means of changing mode in the auth modal */
  LOGIN_AND_SIGNUP: 'LOGIN_AND_SIGNUP',
  /** @type {AuthModalMode} Allow or display login mode */
  LOGIN: 'LOGIN',
  /** @type {AuthModalMode} Allow or display signup mode */
  SIGNUP: 'SIGNUP',
  /** @type {AuthModalMode} Display forgot password mode */
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
};

/**
 * Used to set both the allowed and current mode of the auth modal.
 * @typedef {String} AuthModalMode
 */



// WEBPACK FOOTER //
// ./src/js/auth/enums/AuthModalMode.js